import { letterAnimation } from "../../variants/variants";
import { motion } from "framer-motion";
import Footer from "../Footer/Footer";
import "./Header.scss";

const headerItemVariant = {
  initial: {
    opacity: 0,
    scale: 0.5,
  },
  animate: {
    opacity: 1,
    scale: 1,
  },
  transition: {
    duration: 1,
    ease: "easeOut",
  },
};
const scrollCircleVariant = {
  initial: {
    opacity: 0.9,
    translateY: -(window.innerHeight / 2 - 150),
    scale: 2,
  },
  animate: {
    opacity: 1,
    translateY: 0,
    scale: 1,
  },
  transition: {
    ease: "easeOut",
  },
};

const Header = ({ setCursorVariant }) => {
  const objectEnter = () => {
    setCursorVariant("text");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      transition={{ staggerChildren: 0.5, delayChildren: 2 }}
      className="header-wrapper"
      data-scroll-section
      id="home"
    >
      <div className="header-circ">
        <motion.div variants={scrollCircleVariant}>
          <Footer text="scroll to explore - scroll to explore - " />
        </motion.div>
      </div>
      <motion.div variants={headerItemVariant} className="header-text-bar">
        <p
          data-scroll
          data-scroll-direction="horizontal"
          data-scroll-speed="20"
        >
          dhiman portfolio vaibhav dhiman portfolio
        </p>
      </motion.div>
      <motion.div variants={headerItemVariant} className="header-text-bar">
        <p
          data-scroll
          data-scroll-direction="horizontal"
          data-scroll-speed="-20"
        >
          full stack developer
        </p>
      </motion.div>
      <motion.div variants={headerItemVariant} className="header-text-bar">
        <p
          data-scroll
          data-scroll-direction="horizontal"
          data-scroll-speed="20"
        >
          vaibhav dhiman portfolio
        </p>
      </motion.div>

      <div
        className="header-image-wrapper"
        onMouseEnter={objectEnter}
        onMouseLeave={objectLeave}
      >
        <div className="header-outline-wrapper">
          <motion.div
            variants={headerItemVariant}
            className="header-text-outline first-outline"
          >
            <p
              data-scroll
              data-scroll-direction="horizontal"
              data-scroll-speed="20"
            >
              dhiman portfolio vaibhav dhiman portfolio
            </p>
          </motion.div>
          <motion.div
            variants={headerItemVariant}
            className="header-text-outline second-outline"
          >
            <p
              data-scroll
              data-scroll-direction="horizontal"
              data-scroll-speed="-20"
            >
              full stack developer
            </p>
          </motion.div>
          <motion.div
            variants={headerItemVariant}
            className="header-text-outline first-outline"
          >
            <p
              data-scroll
              data-scroll-direction="horizontal"
              data-scroll-speed="20"
            >
              vaibhav dhiman portfolio
            </p>
          </motion.div>
          <motion.div
            variants={headerItemVariant}
            className="header-image"
            style={{ backgroundImage: `url(assets/tt.gif)` }}
          ></motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Header;
